import { render } from "./dashboard-page.vue?vue&type=template&id=704504e9&ts=true"
import script from "./dashboard-page.ts?vue&type=script&lang=ts"
export * from "./dashboard-page.ts?vue&type=script&lang=ts"

import "./dashboard-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__